import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-choose-partner",
	imports: [
		COMMON_IMPORTS,
		GenTableComponent,
		LangValPipe,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row">
			<div class="col-12">
				<app-gen-table
					tableName="partners"
					isCheckItems
					(checkedItemsChanged)="checkedItemsChanged($event)"
				/>

				@if (checkedItems.length) {
					<div>
						<h4>{{ "chosen_items" | langVal }}:</h4>
						<div class="chosen-items">
							@for (row of checkedItems; track row) {
								<div>{{ row.name }}</div>
							}
						</div>
					</div>
				}
				@if (!isFormSubmittable) {
					<p class="error">{{ "is_not_checked" | langVal }}</p>
				}
			</div>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				(clickEv)="onClose.emit(checkedItems)"
				[disabled]="!isFormSubmittable"
				text="select_partner"
			/>
		</div>
	`,
})
export class ChoosePartnerComponent extends Modalable {
	isFormSubmittable: boolean = false
	checkedItems: any[] = []

	checkedItemsChanged(res: any) {
		this.checkedItems = res
		this.isFormSubmittable = this.checkedItems?.length == 1
	}
}
